<div class="row">
  <div class="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-sm-12 offset-sm-0">
    <div
      class="row d-lg-flex justify-content-center d-block mx-0 row-cols-lg-3 flex-nowrap"
    >
      <app-main-plan-card
      *ngIf="identiAlertAvailable && showWideIdentiAlertCard"
      class="main-plan-card mb-4 identialert-mobilview" 
      [content]="mainPlanContent"
      [hideIcon]="hideIcons"
      >
    </app-main-plan-card>
      <!--identibase+-->
      <div
        class="col mb-4 text-center identibaseplus-price-card-wrapper"
      >
        <app-price-card
          [viewOnly]="viewOnly"
          [showShortDescription]="showShortDescription"
          [showInfoLine]="showInfoLine"
          [showFeatures]="appPriceCardFeatureText ? true : showFeatures"
          [buttonLabel]="buttonLabel"
          [hidePrices]="hidePrices"
          [disabledBuyNow]="!identibasePlusAvailable"
          [disabled]="disabled"
          [showPeachBanner]="showPeachBanner"
          [planId]="pricingPlans.identibasePlus"
          [hideIcon]="hideIcons"
          [hasBuyNow]="hasBuyNow"
          (onSelect)="select($event)"
          (onNavigateToProductPage)="
            onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS)
          "
          [highlighted]="false"
          imageUri="/assets/images/pricingTable/identibasePlus.svg"
          planTitle="identibase+"
          [planLongSubtitle]="appPriceCardFeatureText ? 'Secure & up to date details' : 'For less than 3p per day, activate your pet’s Digital ID with:'"
          [hidePlusFromSubtitle]="true"
          [features]="appPriceCardFeatureText ? appPriceCardFeatureText : getFeaturesFor(planFeatureService.identiBasePlusPlanName)"
          yearlyPrice="£15"
          [descriptionList]="appPriceCardFeatureText"
          [description]="appPriceCardFeatureText ? '' 
          :  'Get your missing pet home more quickly by activating your pet’s Digital ID. And, with identibase+, keep the Digital ID up to date withunlimited changes to your details.'"
        ></app-price-card>
      </div>
  
      <!--Identialert-->
      <div *ngIf="!showWideIdentiAlertCard" class="col position-relative mb-4 text-center">
        <app-price-card
          [viewOnly]="viewOnly"
          [showShortDescription]="showShortDescription"
          [showInfoLine]="showInfoLine"
          [showFeatures]="appAlertPriceCardFeatureText ? true : showFeatures"
          [buttonLabel]="buttonLabel"
          [hidePrices]="hidePrices"
          [disabledBuyNow]="!identiAlertAvailable"
          [disabled]="disabled"
          [showPeachBanner]="showPeachBanner"
          [hideIcon]="hideIcons"
          [hasBuyNow]="hasBuyNow"
          [planId]="pricingPlans.identiAlertAnnual"
          [monthlyPlanId]="pricingPlans.identiAlertMonthly"
          (onSelect)="select($event)"
          (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIALERT)"
          [highlighted]="false"
          [features]="appAlertPriceCardFeatureText ? appAlertPriceCardFeatureText : getFeaturesFor(planFeatureService.identiAlertPlanName)"
          imageUri="/assets/images/pricingTable/identialert.svg"
          planTitle="identialert"
          planShortSubtitle="Everything from identibase+"
          planLongSubtitle="For less than 9p per day, get everything from identibase+"
          yearlyPrice="£36"
          monthlyPrice="£4.99"
          priceNote="(12 month contract)"
          [descriptionList]="appAlertPriceCardFeatureText"
          [description]="appAlertPriceCardFeatureText ? '' :
          'The fastest way to find your missing pet. A 24/7 network of pet finders - with alerts sent to every vet, warden, rescue centre, police and identibase customers in your area.'"
        ></app-price-card>
        <div *ngIf="promoPopupOpen" class="row">
          <div class="col-10 p-1 pb-2 offset-1 promo">
            <div class="row icon-container">
              <div class="col-12 d-flex flex-row justify-content-end p-0">
                <a [routerLink]="" (click)="closePromoPopup()" class="close-promo">
                  <fa-icon [icon]="['fas', 'times']"></fa-icon>
                </a>
              </div>
            </div>
            <p class="mt-2 mb-0">USE CODE Alert20 and get</p>
            <p class="mt-0 mb-0">identialert for the same price as identibase+</p>
            <p class="mt-0 mb-1 promo-subtitle">
              £20 off alert for the first year renewal at full price annually. Available until 30
              November
            </p>
            <a routerLink="/perk-terms" fragment="alert" class="promo-subtitle">Click for terms.</a>
          </div>
        </div>
      </div>
      
      <app-main-plan-card
        *ngIf="showWideIdentiAlertCard"
        class="main-plan-card mb-4 identialert-desktopview" 
        [content]="mainPlanContent"
        [hideIcon]="hideIcons"
        [disabledBuyNow]="!identiAlertAvailable"
        >
      </app-main-plan-card>
  
      <!--Identifind-->
      <div class="col mb-4 text-center">
        <app-price-card
          [viewOnly]="viewOnly"
          [showShortDescription]="showShortDescription"
          [showInfoLine]="showInfoLine"
          [showFeatures]="showFeatures"
          [buttonLabel]="buttonLabel"
          [hidePrices]="hidePrices"
          [disabled]="disabled"
          [disabledBuyNow]="!identiFindAvailable"
          [hideIcon]="hideIcons"
          [planId]="pricingPlans.identiAlertFind"
          [hasBuyNow]="hasBuyNow"
          [showPeachBanner]="showPeachBanner"
          (onSelect)="select(identiFindSelected)"
          (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIFIND)"
          [highlighted]="false"
          [features]="getFeaturesFor(planFeatureService.identiFindPlanName)"
          imageUri="/assets/images/pricingTable/identifind.svg"
          planTitle="identifind"
          planShortSubtitle="Combine identialert with a PitPat GPS Tracker"
          planLongSubtitle="Get everything from identialert"
          yearlyPrice="£36"
          [oneOffPrice]="'+£129 one-off payment'"
          [description]="'Real time pet location tracking Award-winning activity monitoring to track exercise, distance & rest'"
          [warning]="doesTheUserHaveOnlyCat ? 'Register your interest now' : null"
          [doesTheUserHaveOnlyCats]="doesTheUserHaveOnlyCats()"
        ></app-price-card>
      </div>
    </div>
  </div>
</div>
